import { formatRelativeTime } from "@verse/shared";

const Time = (iso) => formatRelativeTime(iso);

export default Time;
